// Utility to add tenant header to all API requests
// BUILD MARKER: $(date +%s)
export const fetchWithTenant = async (url, options = {}) => {
  const tenantId = localStorage.getItem('currentTenantId');
  
  // This MUST show in console
  console.log('%c[TENANT-FETCH]', 'background: red; color: white', url, 'tenantId:', tenantId);
  
  const headers = {
    ...options.headers,
  };
  if (tenantId) {
    headers['x-tenant-id'] = tenantId;
  }
  return fetch(url, { ...options, headers, credentials: 'include' });
};

export default fetchWithTenant;
